import React from 'react'
import { Card, CardHeader, Divider, FormControl, Grid, InputLabel, MenuItem, Select } from '@mui/material'
import { PropertyList } from '../../../../../components/PropertyList'
import CircularLoading from '../../../../../components/CircularProgress'
import { IMerchant } from '../../../../../types/merchant'

interface FilterGroupProps {
  isLoading: boolean
  merchant?: IMerchant
  updateMerchant?: (data: Partial<IMerchant>) => void
}

const menuItemsStatusType = [
  {
    label: 'ไม่แสดง',
    value: 0,
  },
  {
    label: 'แสดง',
    value: 1,
  },
]

const MerchantPermissionCard = ({ isLoading, merchant, updateMerchant }: FilterGroupProps) => {

  return (
    <>
      <CircularLoading isLoading={isLoading} />
      <Card
        sx={{
          padding: 2,
        }}>
        <CardHeader title="ตั้งค่าการแสดงผล" />
        <Divider />
        <PropertyList>
          <Grid container spacing={2}>
            <Grid item xs={12} lg={6}>
              <FormControl variant="filled" fullWidth>
                <InputLabel id="sales-label">ยอดขาย</InputLabel>
                <Select
                  id="sales"
                  name="sales"
                  labelId="sales-label"
                  value={!!merchant?.config.display?.sales ? 1 : 0}
                  onChange={(e) => updateMerchant?.({
                    config: {
                      ...merchant?.config,
                      display: { ...merchant?.config.display, sales: !!e.target.value },
                    },
                  })}
                  fullWidth
                >
                  {
                    menuItemsStatusType.map((item) => (
                      <MenuItem value={item.value} key={item.value}>
                        {item.label}
                      </MenuItem>
                    ))
                  }
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} lg={6}>
              <FormControl variant="filled" fullWidth>
                <InputLabel id="cost-label">รายจ่าย</InputLabel>
                <Select
                  id="cost"
                  name="cost"
                  labelId="cost-label"
                  value={!!merchant?.config.display?.cost ? 1 : 0}
                  onChange={(e) => updateMerchant?.({
                    config: {
                      ...merchant?.config,
                      display: { ...merchant?.config.display, cost: !!e.target.value },
                    },
                  })}
                  fullWidth
                >
                  {
                    menuItemsStatusType.map((item) => (
                      <MenuItem value={item.value} key={item.value}>
                        {item.label}
                      </MenuItem>
                    ))
                  }
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} lg={6}>
              <FormControl variant="filled" fullWidth>
                <InputLabel id="profit-label">กำไร</InputLabel>
                <Select
                  id="profit"
                  name="profit"
                  labelId="profit-label"
                  value={!!merchant?.config.display?.profit ? 1 : 0}
                  onChange={(e) => updateMerchant?.({
                    config: {
                      ...merchant?.config,
                      display: { ...merchant?.config.display, profit: !!e.target.value },
                    },
                  })}
                  fullWidth
                >
                  {
                    menuItemsStatusType.map((item) => (
                      <MenuItem value={item.value} key={item.value}>
                        {item.label}
                      </MenuItem>
                    ))
                  }
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} lg={6}>
              <FormControl variant="filled" fullWidth>
                <InputLabel id="order-label">จำนวนคำสั่งซื้อ</InputLabel>
                <Select
                  id="order"
                  name="order"
                  labelId="order-label"
                  value={!!merchant?.config.display?.order ? 1 : 0}
                  onChange={(e) => updateMerchant?.({
                    config: {
                      ...merchant?.config,
                      display: { ...merchant?.config.display, order: !!e.target.value },
                    },
                  })}
                  fullWidth
                >
                  {
                    menuItemsStatusType.map((item) => (
                      <MenuItem value={item.value} key={item.value}>
                        {item.label}
                      </MenuItem>
                    ))
                  }
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} lg={6}>
              <FormControl variant="filled" fullWidth>
                <InputLabel id="unit-label">จำนวนชิ้นที่ขายได้</InputLabel>
                <Select
                  id="unit"
                  name="unit"
                  labelId="unit-label"
                  value={!!merchant?.config.display?.unit ? 1 : 0}
                  onChange={(e) => updateMerchant?.({
                    config: {
                      ...merchant?.config,
                      display: { ...merchant?.config.display, unit: !!e.target.value },
                    },
                  })}
                  fullWidth
                >
                  {
                    menuItemsStatusType.map((item) => (
                      <MenuItem value={item.value} key={item.value}>
                        {item.label}
                      </MenuItem>
                    ))
                  }
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} lg={6}>
              <FormControl variant="filled" fullWidth>
                <InputLabel id="comission-label">ค่าคอมมิชชั่น</InputLabel>
                <Select
                  id="comission"
                  name="comission"
                  labelId="comission-label"
                  value={!!merchant?.config.display?.comission ? 1 : 0}
                  onChange={(e) => updateMerchant?.({
                    config: {
                      ...merchant?.config,
                      display: { ...merchant?.config.display, comission: !!e.target.value },
                    },
                  })}
                  fullWidth
                >
                  {
                    menuItemsStatusType.map((item) => (
                      <MenuItem value={item.value} key={item.value}>
                        {item.label}
                      </MenuItem>
                    ))
                  }
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} lg={6}>
              <FormControl variant="filled" fullWidth>
                <InputLabel id="return-label">ยอดตีกลับ</InputLabel>
                <Select
                  id="return"
                  name="return"
                  labelId="return-label"
                  value={!!merchant?.config.display?.return ? 1 : 0}
                  onChange={(e) => updateMerchant?.({
                    config: {
                      ...merchant?.config,
                      display: { ...merchant?.config.display, return: !!e.target.value },
                    },
                  })}
                  fullWidth
                >
                  {
                    menuItemsStatusType.map((item) => (
                      <MenuItem value={item.value} key={item.value}>
                        {item.label}
                      </MenuItem>
                    ))
                  }
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} lg={6}>
              <FormControl variant="filled" fullWidth>
                <InputLabel id="crm-label">ยอด CRM</InputLabel>
                <Select
                  id="crm"
                  name="crm"
                  labelId="crm-label"
                  value={!!merchant?.config.display?.crm ? 1 : 0}
                  onChange={(e) => updateMerchant?.({
                    config: {
                      ...merchant?.config,
                      display: { ...merchant?.config.display, crm: !!e.target.value },
                    },
                  })}
                  fullWidth
                >
                  {
                    menuItemsStatusType.map((item) => (
                      <MenuItem value={item.value} key={item.value}>
                        {item.label}
                      </MenuItem>
                    ))
                  }
                </Select>
              </FormControl>
            </Grid>
          </Grid>
        </PropertyList>
      </Card>
    </>
  )
}

export default MerchantPermissionCard
